import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doc-ppt",
  "use": "icon-doc-ppt-usage",
  "viewBox": "0 0 30.43 32.77",
  "content": "<symbol viewBox=\"0 0 30.43 32.77\" id=\"icon-doc-ppt\">\r\n    <path d=\"M29.24,0h-21A1.19,1.19,0,0,0,7.1,1.19V7.43h1V1.19A.2.2,0,0,1,8.29,1h21a.2.2,0,0,1,.19.19V19.48H15.85V31.77H8.29a.2.2,0,0,1-.19-.2V17h-1V31.57a1.19,1.19,0,0,0,1.19,1.2h8.19l14-12.57v-19A1.19,1.19,0,0,0,29.24,0ZM16.85,31.09V20.48H28.63ZM4.62,9.51a2,2,0,0,0-.85-.76A3,3,0,0,0,2.5,8.49H0v6.42H1.32V12.65H2.48a2.73,2.73,0,0,0,1.79-.55,1.84,1.84,0,0,0,.64-1.49A2.12,2.12,0,0,0,4.62,9.51ZM3.3,11.33a1.18,1.18,0,0,1-.8.24H1.32v-2H2.53a1.08,1.08,0,0,1,.77.3,1.08,1.08,0,0,1,.28.76A.93.93,0,0,1,3.3,11.33Zm7.14-1.82a2,2,0,0,0-.85-.76,3,3,0,0,0-1.27-.26H5.82v6.42H7.14V12.65H8.3a2.73,2.73,0,0,0,1.79-.55,1.84,1.84,0,0,0,.64-1.49A2.12,2.12,0,0,0,10.44,9.51ZM9.12,11.33a1.18,1.18,0,0,1-.8.24H7.14v-2H8.35a1,1,0,0,1,1,1.06A.93.93,0,0,1,9.12,11.33Zm7.35-2.84V9.56h-2v5.35H13.18V9.56H11.24V8.49Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/doc-ppt.svg
// module id = Gt49
// module chunks = 0